import React, { useState } from 'react'
import styled from 'styled-components'
import ReactMapGL, { Marker, WebMercatorViewport } from 'react-map-gl'
// import { Bounds } from '@types/react-map-gl'

const HouseIconSt = styled.img`
  height: 40px;
`

interface Props {
  venueCoords: { latitude: number | string, longitude: number | string }
  airportCoords: { latitude: number | string, longitude: number | string }[]
}

const getBoundsForPoints = (points: {
  latitude: number[]
  longitude: number[]
}) => {
  const cornersLongLat = [
    [Math.min(...points.longitude), Math.min(...points.latitude)],
    [Math.max(...points.longitude), Math.max(...points.latitude)],
  ] as any

  // Use WebMercatorViewport to get center longitude/latitude and zoom
  const viewport = new WebMercatorViewport({
    width: 800,
    height: 600,
  }).fitBounds(cornersLongLat, { padding: 200 }) // Can also use option: offset: [0, -100]

  const { longitude, latitude, zoom } = viewport
  return { longitude, latitude, zoom: zoom - 1 }
}

const VenueMap = ({ airportCoords, venueCoords }: Props) => {
  const points = {
    latitude: [
      typeof venueCoords.latitude === 'string' ? parseFloat(venueCoords.latitude) : venueCoords.latitude || 0,
      ...airportCoords.map(v => typeof v.latitude === 'string' ? parseFloat(v.latitude) : v.latitude),
    ].filter(coord => coord),
    longitude: [
      typeof venueCoords.longitude === 'string' ? parseFloat(venueCoords.longitude) : venueCoords.longitude || 0,
      ...airportCoords.map(v => typeof v.longitude === 'string' ? parseFloat(v.longitude) : v.longitude),
    ].filter(coord => coord),
  }

  const bounds = (venueCoords.latitude || airportCoords.length > 1) ?  getBoundsForPoints(points) : { latitude: parseFloat(airportCoords[0]?.latitude as any) || 0, longitude: parseFloat(airportCoords[0]?.longitude as any) || 0, zoom: 5 }

  const [viewport, setViewport] = useState({
    width: '100%',
    height: '100%',
    ...bounds,
  })

  return (
    <ReactMapGL
      mapStyle="mapbox://styles/thatstheone/ckf31ln0q09as19nsz782wm16"
      mapboxApiAccessToken={process.env.NEXT_PUBLIC_MAPBOX_PK}
      onViewportChange={(action: any) =>
        setViewport({
          width: '100%',
          height: '100%',
          latitude: action.latitude,
          longitude: action.longitude,
          zoom: action.zoom,
        })
      }
      {...viewport}
    >
      {venueCoords.latitude && (
        <Marker
        latitude={typeof venueCoords.latitude === 'string' ? parseFloat(venueCoords.latitude) : venueCoords.latitude}
        longitude={typeof venueCoords.longitude === 'string' ? parseFloat(venueCoords.longitude) : venueCoords.longitude}
        offsetLeft={-20}
        offsetTop={-10}
      >
        <HouseIconSt src="/images/house-white-bg.svg" />
      </Marker>
      )}

      {airportCoords.map(a => (
        <Marker
          key={a.latitude}
          latitude={typeof a.latitude === 'string' ?  parseFloat(a.latitude) : a.latitude || 0}
          longitude={typeof a.longitude === 'string' ?  parseFloat(a.longitude) : a.longitude || 0}
          offsetLeft={-20}
          offsetTop={-10}
        >
          <HouseIconSt src="/images/plane-white-bg.svg" />
        </Marker>
      ))}
    </ReactMapGL>
  )
}

export default VenueMap
